import { Component, OnInit,OnDestroy, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Site } from 'solar-bo';

import { SolarBase1Component } from './solar-base1.component';

@Component({
  selector: 'app-solar-base',
  template: ''
})
export class SolarBaseComponent extends SolarBase1Component implements OnInit, OnDestroy {

  
  public constructor() {
    super();
  }

  uiiseditablemodel(element:any) {
    return true;
  }
  ngOnInit() {}

  ngOnDestroy() {}


  saveSiteEvent(dialogRef: MatDialogRef<any>,itemToEdit:Site,site:Site) {

  }


}